
<template>
  <div class="fam-role">
    <div class="role-header-box flex align-items-center">
      <el-input v-model="query.keyword" placeholder="请输入角色名称" clearable @change="fetchData" style="width: 200px;" class="hd" />
      <el-button type="success" icon="el-icon-plus" @click="editor(0)" class="ft">新建角色</el-button>
    </div>
    <div class="a-card" v-loading="loading">
      <el-card v-for="role in currentList" :key="role.roleid" class="card-container" shadow="never">
        <div class="flex card-body">
          <div class="card-item">
            <span class="text-bold font-md">{{ role.title }}</span>
            <div v-if="role.is_admin == 1" class="mt-lg text-muted">{{ role.desc }}</div>
            <div v-else class="frame-box mt-lg text-muted">
              <span>{{ role.desc }}</span>
            </div>
          </div>
          <div class="card-item right-area">
            <div class="member-box text-align-center">
              <div class="font-2x number">{{ role.user_count }}</div>
              <div class="mt-sm">人 数</div>
            </div>
            <div class="oprea-box">
              <div v-if="role.is_admin !== 1" class="o-item">
                <el-button type="text" @click="editor(role.roleid)">编辑</el-button>
                <el-button type="text" @click="deleteRole(role)">删除</el-button>
              </div>
              <div v-else class="text-muted">不可编辑删除</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <div v-if="currentList.length == 0" class="empty">
      <img class="image huger mt-lg" src="@/assets/no-data.png" />
      <div class="font-md mb-hg">暂无数据</div>
    </div>
    <role-editor v-if="showEditor" :show.sync="showEditor" :roleid="roleid" @change="fetchData"></role-editor>
  </div>
</template>

<script>
import { roleGetallApi, roleDeleteApi } from '@/api/fam/famMemberApi'
export default {
  name: 'FamRole',
  components: {
    RoleEditor: () => import('./components/RoleEditor.vue')
  },
  data() {
    return {
      roleList: [],
      loading: false,
      query: {
        keyword: ''
      },
      showEditor: false,
      roleid: -1,
      currentList: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      roleGetallApi(this.query).then(res => {
        if (!res.errno) {
          this.roleList = res.data.list
          this.currentList = Object.assign({}, this.roleList)
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },

    editor(item) {
      this.roleid = item
      this.showEditor = true
    },

    deleteRole(item) {
      this.$confirm(`即将删除角色 <span class="text-primary">${item.title}</span> ，删除后对应成员将只拥有基本权限，是否继续？`, '提示', {
        type: 'error',
        dangerouslyUseHTMLString: true
      }).then(() => {
        roleDeleteApi({ roleid: item.roleid }).then(res => {
          if (!res.errno) {
            // 操作成功处理
            this.$message.success('删除成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fam-role {
  .role-header-box {
    width: 1180px;
    display: flex;
    margin: 20px auto 0;
    justify-content: space-between;
  }
  .a-card {
    min-height: 720px;
    width: 1180px;
    margin: 20px auto;

    .card-container {
      margin-top: 10px;
      .card-body {
        padding: 10px 20px;
        height: 145px;
        .card-item {
          flex: 1;
          position: relative;
          .frame-box {
            width: 464px;
            height: 54px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          .oprea-box {
            position: absolute;
            right: 0px;
            top: 47px;
          }
        }
        .right-area {
          display: flex;
          justify-content: center;
          align-items: center;
          .member-box {
            text-align: center;
          }
        }
      }
    }
  }
  .empty {
    margin: 40px auto;
    width: 200px;
    text-align: center;
  }
}
</style>